import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../globals';

@Injectable()
export class CartaMenuServices {

  public firestore: any;
  public cartas_menu_combo_array_tmp: any = [];
  public cartas_menu_combo_array: any;
  public get_cartas_menu_combo: any;
  public total_cartas = 0;
  public total_menus = 0;
  public total_combos = 0;

  constructor(public afs: AngularFirestore,
    public http: HttpClient,
    public globals: Globals) {
    this.firestore = firebase.firestore();
  }

  async getPagesCartasMenusCombos(loader) {
    this.get_cartas_menu_combo = loader;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    await this.http.post(this.globals.analytics_path + 'paginate/paginate_cartas_menu_combos', params, {})
      .subscribe(async res => {
        this.cartas_menu_combo_array_tmp = res['list_elements'];
        if (this.cartas_menu_combo_array_tmp.length > 0) { //Si hay paginas
          this.getListCartaMenuCombo();
        } else { //Si no hay paginas
          this.get_cartas_menu_combo = true;
        }
      });
  }

  getListCartaMenuCombo() {
    this.get_cartas_menu_combo = true;
    let limit = this.globals.checkLimitsByLicense('menus', 'max_menus');
    let limit_cartas = 0;
    let limit_menus = 0;
    let limit_combos = 0;

    //Quitamos la carta takeaway
    let index_carta_tk = this.cartas_menu_combo_array_tmp.findIndex(x => x.type === 'carta' && x.tk_active === true);
    if (index_carta_tk != -1) {
      this.cartas_menu_combo_array_tmp.splice(index_carta_tk, 1);
    }
    //Ordenamos el array
    this.cartas_menu_combo_array_tmp.sort((a, b) => {
      const aName = this.globals.returnLangCartaMenuCombo(a);
      const aType = a.type;
      const bName = this.globals.returnLangCartaMenuCombo(b);
      const bType = b.type;

      // Ordenamos por nombre
      if (aName < bName) {
        return -1;
      } else if (aName > bName) {
        return 1;
      }

      // Si los nombres son iguales, ordenamos por tipo
      return aType - bType;
    });

    //Recorremos el array filtrada
    for (let element of this.cartas_menu_combo_array_tmp) {
      element._active = true;
      if (element.type == 'carta') {
        this.total_cartas++;
        if (limit_cartas >= limit && limit != -1) {
          //si supera el limite de de productos de la version, desactivamos el producto
          element._active = false;
        }
        limit_cartas++;
      } else if (element.type == 'menu') {
        this.total_menus++;
        if (limit_menus >= limit && limit != -1) {
          //si supera el limite de de productos de la version, desactivamos el producto
          element._active = false;
        }
        limit_menus++;
      } else {
        this.total_combos++;
        if (limit_combos >= limit && limit != -1) {
          //si supera el limite de de productos de la version, desactivamos el producto
          element._active = false;
        }
        limit_combos++;
      }
    }

    this.get_cartas_menu_combo = true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/cartas-menus/services.ts